import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { DesignAngularKitModule } from 'design-angular-kit';

@Component({
  selector: 'app-rapid-search',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule, FormsModule, ReactiveFormsModule, RouterModule],
  templateUrl: './rapid-search.component.html',
  styleUrl: './rapid-search.component.scss'
})
export class RapidSearchComponent {

  researchForm: FormGroup;

  constructor(private _fb: FormBuilder, private router: Router) {
    this.researchForm = this._fb.group({
      name: [null],
      surname: [null],
      patientFiscalCode: [null],
      tansitionCode: [null]
    });
  }

  find() {
    this.router.navigate(['/request-list'], {
      queryParams: this.researchForm.value
  });
  }
}
